/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const ArrowForward16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M8 1a7 7 0 110 14A7 7 0 018 1zm1.86 4.152a.5.5 0 00-.558-.111l-.08.043-.07.057a.5.5 0 00-.111.557l.043.08L10.49 7.5H4.5l-.09.008a.5.5 0 000 .984l.09.008h5.99l-1.406 1.723-.043.079a.5.5 0 00.818.546l2.057-2.57.023-.039.026-.055.019-.058a.502.502 0 000-.252l-.019-.058-.017-.037-.032-.056-2.057-2.57z"
        />
    </AccessibleSVG>
);

export default ArrowForward16;
